// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RsaQZtr5cj8N7DhluA4t{align-items:center;margin-bottom:24px;display:flex}.nDOfMWFGm1oDAZzAdLfQ{margin-right:12px}.AfYehZ7dpj8g1vsMQAb1{flex-direction:column;gap:4px;display:flex}.K78T7N0cmyUBhbcYlwf4{color:var(--content-primary-primary)}.MgZBoQmbb9ErKrrAqRAV{color:var(--content-primary-tertiary)}.CpW5MdLlmm8kZYd4eZD_{color:var(--content-primary-tertiary);margin-bottom:16px}.qs_9y3TZBYMCUyJqUpSD{flex-direction:column;gap:16px;display:flex}.Kk7qa3xCWpUTpBxpTweC{display:flex}.dZ69GXFweQwq91ylOprf{align-items:center;width:130px;display:flex}.RUwcnisUb_c3r5c1hAfo{color:var(--content-primary-tertiary);margin-right:8px}.qaHBAcBeEjcBLStlF4le{color:var(--content-primary-tertiary)}.FwXSbnMYkkwFl4oQedyl{color:var(--content-primary-primary)}.f66yomY0rNkc4obGL3BZ{padding-top:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"info": `RsaQZtr5cj8N7DhluA4t`,
	"info__avatar": `nDOfMWFGm1oDAZzAdLfQ`,
	"infoAvatar": `nDOfMWFGm1oDAZzAdLfQ`,
	"info__content": `AfYehZ7dpj8g1vsMQAb1`,
	"infoContent": `AfYehZ7dpj8g1vsMQAb1`,
	"info__title": `K78T7N0cmyUBhbcYlwf4`,
	"infoTitle": `K78T7N0cmyUBhbcYlwf4`,
	"info__desc": `MgZBoQmbb9ErKrrAqRAV`,
	"infoDesc": `MgZBoQmbb9ErKrrAqRAV`,
	"details__title": `CpW5MdLlmm8kZYd4eZD_`,
	"detailsTitle": `CpW5MdLlmm8kZYd4eZD_`,
	"details__content": `qs_9y3TZBYMCUyJqUpSD`,
	"detailsContent": `qs_9y3TZBYMCUyJqUpSD`,
	"field": `Kk7qa3xCWpUTpBxpTweC`,
	"field__label": `dZ69GXFweQwq91ylOprf`,
	"fieldLabel": `dZ69GXFweQwq91ylOprf`,
	"field__icon": `RUwcnisUb_c3r5c1hAfo`,
	"fieldIcon": `RUwcnisUb_c3r5c1hAfo`,
	"field__name": `qaHBAcBeEjcBLStlF4le`,
	"fieldName": `qaHBAcBeEjcBLStlF4le`,
	"field__value": `FwXSbnMYkkwFl4oQedyl`,
	"fieldValue": `FwXSbnMYkkwFl4oQedyl`,
	"wrapBtn": `f66yomY0rNkc4obGL3BZ`
};
export default ___CSS_LOADER_EXPORT___;
